export default __webpack_public_path__ + "static/PPEditorialNew-LightItalic-17a508c776dc1d600364d4c0114ada3c.ttf";